import Vue from 'vue'
import { 
    BCarousel, 
    BCarouselSlide, 
    BNavbar, 
    BNavbarBrand, 
    BNavbarToggle, 
    BNavbarNav, 
    BCollapse, 
    BNavItem 
} from 'bootstrap-vue'

Vue.component('b-carousel', BCarousel)
Vue.component('b-carousel-slide', BCarouselSlide)
Vue.component('b-navbar', BNavbar)
Vue.component('b-navbar-brand', BNavbarBrand)
Vue.component('b-navbar-toggle', BNavbarToggle)
Vue.component('b-navbar-nav', BNavbarNav)
Vue.component('b-collapse', BCollapse)
Vue.component('b-nav-item', BNavItem)